(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-introduce-v3"]) return;
  try {
    
// Luary About Us v3 Interactive Enhancements
document.addEventListener('DOMContentLoaded', function() {
  // Smooth reveal animation on scroll
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);

  // Apply animation to content blocks
  const aboutRows = document.querySelectorAll('.luary-about-row');
  aboutRows.forEach((row, index) => {
    row.style.opacity = '0';
    row.style.transform = 'translateY(30px)';
    row.style.transition = `all 0.6s ease ${index * 0.2}s`;
    observer.observe(row);
  });

  // Simple image hover - no JavaScript interference
  // Let CSS handle the hover effects naturally

  // Content hover effects
  const introContents = document.querySelectorAll('.luary-intro-content');
  introContents.forEach(content => {
    content.addEventListener('mouseenter', function() {
      this.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
    });
    
    content.addEventListener('mouseleave', function() {
      this.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
    });
  });

  // Parallax effect for background elements
  window.addEventListener('scroll', () => {
    const scrolled = window.pageYOffset;
    const aboutSection = document.querySelector('.luary-about-section');
    
    if (aboutSection) {
      const rate = scrolled * -0.3;
      aboutSection.style.backgroundPosition = `center ${rate}px`;
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-servicebox-v3"]) return;
  try {
    
// Luary Services Interactive Enhancements
document.addEventListener('DOMContentLoaded', function() {
  // Smooth reveal animation on scroll
  const observerOptions = {
    threshold: 0.15,
    rootMargin: '0px 0px -30px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
      }
    });
  }, observerOptions);

  // Apply staggered animation to service items
  const serviceItems = document.querySelectorAll('.luary-service-item');
  serviceItems.forEach((item, index) => {
    item.style.transitionDelay = `${index * 0.1}s`;
    observer.observe(item);
  });

  // Enhanced hover effects for service cards
  const serviceCards = document.querySelectorAll('.luary-service-card');
  serviceCards.forEach(card => {
    card.addEventListener('mouseenter', function() {
      // Add glow effect
      this.style.boxShadow = '0 25px 60px rgba(215, 198, 230, 0.15), 0 0 0 1px rgba(215, 198, 230, 0.2)';
    });
    
    card.addEventListener('mouseleave', function() {
      // Remove glow effect
      this.style.boxShadow = '0 10px 40px rgba(61, 41, 38, 0.06)';
    });
  });

  // Icon animation enhancement
  const serviceIcons = document.querySelectorAll('.luary-service-icon');
  serviceIcons.forEach(icon => {
    icon.addEventListener('mouseenter', function() {
      this.style.transform = 'scale(1.15) rotate(8deg)';
    });
    
    icon.addEventListener('mouseleave', function() {
      this.style.transform = 'scale(1) rotate(0deg)';
    });
  });

  // Add floating animation to icons
  serviceIcons.forEach((icon, index) => {
    const delay = index * 0.5;
    setInterval(() => {
      icon.style.transform += ' translateY(-2px)';
      setTimeout(() => {
        icon.style.transform = icon.style.transform.replace(' translateY(-2px)', '');
      }, 1000);
    }, 3000 + delay * 1000);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-template"] && !Shopify.designMode) return;
  try {
    
// Luary Contact Page Refined Interactive Enhancements
document.addEventListener('DOMContentLoaded', function() {
  // Enhanced form validation
  const inputs = document.querySelectorAll('.contact-page input, .contact-page textarea');
  
  inputs.forEach(input => {
    input.addEventListener('focus', function() {
      this.style.borderColor = '#D7C6E6';
    });
    
    input.addEventListener('blur', function() {
      if (this.value.trim() !== '') {
        this.style.borderColor = '#D7C6E6';
        this.style.background = 'rgba(224, 219, 227, 0.05)';
      } else {
        this.style.borderColor = 'rgba(61, 41, 38, 0.12)';
        this.style.background = '#fff';
      }
    });
  });
  
  // Newsletter form enhancement
  const newsletterInput = document.querySelector('.section-newsletter-v3 input[type="email"]');
  if (newsletterInput) {
    newsletterInput.addEventListener('focus', function() {
      this.style.borderColor = '#D7C6E6';
    });
  }
  
  // Modern FAQ functionality for Bootstrap 4
  const faqHeadings = document.querySelectorAll('.engoc-faq-heading');
  
  faqHeadings.forEach(heading => {
    heading.addEventListener('click', function() {
      const target = this.getAttribute('data-target');
      const targetElement = document.querySelector(target);
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      const verticalLine = this.querySelector('.vertical-line');
      const plusIcon = this.querySelector('.faq-plus-icon');
      
      // Check if the target is currently expanded
      const isCurrentlyOpen = targetElement && targetElement.classList.contains('show');
      
      // Update aria-expanded
      this.setAttribute('aria-expanded', !isCurrentlyOpen);
      
      // Animate icon
      if (!isCurrentlyOpen) {
        if (verticalLine) verticalLine.style.transform = 'translateX(-50%) scaleY(0)';
        if (plusIcon) plusIcon.style.transform = 'translate(-50%, -50%) rotate(180deg)';
      } else {
        if (verticalLine) verticalLine.style.transform = 'translateX(-50%) scaleY(1)';
        if (plusIcon) plusIcon.style.transform = 'translate(-50%, -50%) rotate(0deg)';
      }
    });
  });
  
  // Handle Bootstrap 4 collapse events
  $(document).on('show.bs.collapse', '.collapse', function() {
    const button = document.querySelector(`[data-target="#${this.id}"]`);
    if (button) {
      button.setAttribute('aria-expanded', 'true');
      const verticalLine = button.querySelector('.vertical-line');
      const plusIcon = button.querySelector('.faq-plus-icon');
      if (verticalLine) verticalLine.style.transform = 'translateX(-50%) scaleY(0)';
      if (plusIcon) plusIcon.style.transform = 'translate(-50%, -50%) rotate(180deg)';
    }
  });
  
  $(document).on('hide.bs.collapse', '.collapse', function() {
    const button = document.querySelector(`[data-target="#${this.id}"]`);
    if (button) {
      button.setAttribute('aria-expanded', 'false');
      const verticalLine = button.querySelector('.vertical-line');
      const plusIcon = button.querySelector('.faq-plus-icon');
      if (verticalLine) verticalLine.style.transform = 'translateX(-50%) scaleY(1)';
      if (plusIcon) plusIcon.style.transform = 'translate(-50%, -50%) rotate(0deg)';
    }
  });
  
  // Enhanced submit button effect
  const submitBtn = document.querySelector('.luary-submit-btn');
  if (submitBtn) {
    submitBtn.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-2px)';
      this.style.boxShadow = '0 8px 25px rgba(215, 198, 230, 0.4)';
    });
    
    submitBtn.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
      this.style.boxShadow = 'none';
    });
    
    submitBtn.addEventListener('mousedown', function() {
      this.style.transform = 'translateY(0)';
    });
    
    submitBtn.addEventListener('mouseup', function() {
      this.style.transform = 'translateY(-2px)';
    });
  }
  
  // Smooth scroll for internal links
  const links = document.querySelectorAll('a[href^="#"]');
  links.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter_about_v3"] && !Shopify.designMode) return;
  try {
    
// Newsletter V3 Enhanced - JavaScript mejorado
document.addEventListener('DOMContentLoaded', function() {
  const newsletterInput = document.querySelector('.luary-input-enhanced');
  const newsletterBtn = document.querySelector('.luary-btn-enhanced');
  
  if (newsletterInput) {
    // Validación en tiempo real sutil
    newsletterInput.addEventListener('input', function() {
      const email = this.value;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      
      if (email && emailRegex.test(email)) {
        this.style.borderColor = 'rgba(144, 238, 144, 0.6)';
        if (newsletterBtn) {
          newsletterBtn.style.background = '#2A1B18';
        }
      } else if (email && email.length > 3) {
        this.style.borderColor = 'rgba(255, 99, 99, 0.5)';
        if (newsletterBtn) {
          newsletterBtn.style.background = '#3D2926';
        }
      } else {
        this.style.borderColor = 'rgba(61, 41, 38, 0.15)';
        if (newsletterBtn) {
          newsletterBtn.style.background = '#3D2926';
        }
      }
    });
  }
  
  // Prevenir zoom en iOS
  if (window.navigator.userAgent.includes('iPhone') || window.navigator.userAgent.includes('iPad')) {
    if (newsletterInput) {
      newsletterInput.style.fontSize = '16px';
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  let isUpdatingQuantity = false;

  const sanitizeQuantity = (value) => {
    const numericValue = parseInt(String(value || '').replace(/[^\d]/g, ''), 10);
    return Number.isNaN(numericValue) ? 0 : Math.max(0, numericValue);
  };

  const getMaxQuantity = (wrapper) => {
    if (!wrapper || typeof wrapper.dataset.max === 'undefined' || wrapper.dataset.max === '') {
      return null;
    }
    const parsed = parseInt(wrapper.dataset.max, 10);
    return Number.isNaN(parsed) ? null : parsed;
  };

  const setHintMessage = (wrapper, message) => {
    if (!wrapper) {
      return;
    }
    const controls = wrapper.parentElement;
    if (!controls) {
      return;
    }
    const hint = controls.querySelector('.quantity-hint');
    const input = wrapper.querySelector('.qty-input');
    if (!hint || !input) {
      return;
    }
    if (message) {
      hint.textContent = message;
      hint.classList.add('is-visible');
      input.setAttribute('aria-invalid', 'true');
    } else {
      hint.textContent = '';
      hint.classList.remove('is-visible');
      input.removeAttribute('aria-invalid');
    }
  };

  const requestQuantityUpdate = (line, quantity) => {
    if (Number.isNaN(line) || line < 1 || isUpdatingQuantity) {
      return;
    }

    isUpdatingQuantity = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line, quantity })
    })
      .catch(() => {})
      .finally(() => {
        window.location.reload();
      });
  };

  const queueQuantityUpdate = (input, quantity) => {
    const wrapper = input.closest('.quantity-wrapper');
    if (!wrapper) {
      return;
    }

    const previousValue = parseInt(wrapper.dataset.current, 10);
    if (!Number.isNaN(previousValue) && previousValue === quantity) {
      return;
    }

    wrapper.dataset.current = String(quantity);
    const line = parseInt(input.dataset.line, 10);
    requestQuantityUpdate(line, quantity);
  };

  document.addEventListener('click', function(event) {
    const button = event.target.closest('.qty-btn');
    if (!button) {
      return;
    }

    const wrapper = button.closest('.quantity-wrapper');
    const input = wrapper ? wrapper.querySelector('.qty-input') : null;

    if (!input) {
      return;
    }

    let currentValue = sanitizeQuantity(input.value);
    const maxQuantity = getMaxQuantity(wrapper);
    const limitMessage = wrapper && wrapper.dataset.limitMessage ? wrapper.dataset.limitMessage : '';

    if (button.classList.contains('qty-plus')) {
      if (maxQuantity !== null && currentValue >= maxQuantity) {
        input.value = maxQuantity;
        setHintMessage(wrapper, limitMessage);
        return;
      }
      currentValue += 1;
    } else if (button.classList.contains('qty-minus')) {
      currentValue = Math.max(0, currentValue - 1);
    }

    if (maxQuantity === null || currentValue <= maxQuantity) {
      setHintMessage(wrapper);
    }

    input.value = currentValue;
    queueQuantityUpdate(input, currentValue);
  });

  document.addEventListener('input', function(event) {
    const input = event.target.closest('.qty-input');
    if (!input) {
      return;
    }

    input.value = input.value.replace(/[^\d]/g, '');
  });

  document.addEventListener('change', function(event) {
    const input = event.target.closest('.qty-input');
    if (!input) {
      return;
    }

    const wrapper = input.closest('.quantity-wrapper');
    const maxQuantity = getMaxQuantity(wrapper);
    let normalizedValue = sanitizeQuantity(input.value);

    if (maxQuantity !== null && normalizedValue > maxQuantity) {
      normalizedValue = maxQuantity;
      const message = wrapper && wrapper.dataset.limitMessage ? wrapper.dataset.limitMessage : '';
      setHintMessage(wrapper, message);
    } else {
      setHintMessage(wrapper);
    }

    input.value = normalizedValue;
    queueQuantityUpdate(input, normalizedValue);
  });

  document.addEventListener('click', function(event) {
    const removeButton = event.target.closest('.remove-item');
    if (!removeButton) {
      return;
    }

    const line = removeButton.dataset.line;
    if (confirm('¿Estás seguro de que quieres eliminar este artículo?')) {
      window.location.href = `/cart/change?line=${line}&quantity=0`;
    }
  });
  
  // Animaciones de entrada para las cards
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);
  
  // Aplicar animaciones a las cards del carrito
  document.querySelectorAll('.cart-item-card').forEach((card, index) => {
    card.style.opacity = '0';
    card.style.transform = 'translateY(20px)';
    card.style.transition = `opacity 0.6s ease ${index * 0.1}s, transform 0.6s ease ${index * 0.1}s`;
    observer.observe(card);
  });
});

  } catch(e) { console.error(e); }
})();
})();
